import Vue from 'vue'
import Vuex from 'vuex'

const req = require.context('./modules/', true, /\.(js)$/);
let modules = {}
req.keys().map(key => {
  const name = key.match(/\w+\./)[0].match(/\w+/)[0];
  modules[name] = (req(key).default)
});

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    ...modules
  },
  strict: debug
  // plugins: debug ? [createLogger()] : []
})
